export const urlParams = <T extends object>(params: T): string => `?${Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')}`;